export const SET_LANG = "SET_LANG";
export const SET_LANGS_LIST = "SET_LANGS_LIST";
export const SET_LOCALE = "SET_LOCALE";

export function setLangDetails(lang) {
  return async (dispatch) => {
    dispatch({ type: SET_LANG, payload: lang });
  };
}

export function setLangList(langs) {
  return async (dispatch) => {
    dispatch({ type: SET_LANGS_LIST, payload: langs });
  };
}
export function setLocale(locale) {
  return async (dispatch) => {
    dispatch({ type: SET_LOCALE, payload: locale });
  };
}
